module.exports = __webpack_public_path__ + "img/roule_title.e22a587e.png";